export default __webpack_public_path__ + "static/media/tags 1.aff29f61.jpg";